import React from "react";
import { connect } from "react-redux";
import {
  Paper,
  Grid,
  TextField,
  Box,
  FormControl,
  CssBaseline,
  Container,
  Typography,
  Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Helmet } from "react-helmet";
import { Formik } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { USER_ROLE } from "../../components/security/UserRole";
import { DoctorAction } from "../../redux/actions/DoctorAction";
import { AppointmentActions } from "../../redux/actions/AppointmentActions";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    backgroundColor: "#fff",
    padding: theme.spacing(4),
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  typography: {
    margin: theme.spacing(3),
  },
  divider: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
}));

const Blockshedule = (props) => {
  const [isDoctorListRequested, setIsDoctorListRequested] = React.useState(true);
  const [isSubmitted, setSubmitted] = React.useState(false);
  const classes = useStyles();
  const dispatch = useDispatch();
  const userRole = useSelector((state) => state.authentication.user.userRole);
  const doctorList = useSelector((state) => state.doctor.allDoctorList);
  const [startDateTime, setStartDateTime] = React.useState('');
  const [endDateTime, setEndDateTime] = React.useState('');

  
  const doctorUserId = useSelector(
    (state) => state.authentication.user.doctorId
  );
  const [doctorId, setDoctorId] = React.useState(
    userRole === USER_ROLE.DOCTOR ? doctorUserId : ""
  );             
  
  if(userRole === USER_ROLE.DOCTOR){

  }else{
    if(doctorList && doctorList.length <= 0 && isDoctorListRequested){
      setIsDoctorListRequested(false);
      dispatch(DoctorAction.getAllDoctors());
    }
    
  }

  return (
    <Box display="flex" justifyContent="flex-start" mt={2} pt={2}>
      <Helmet>
        <title>RxRapidMad | Block schedule</title>
      </Helmet>
      <Container component="main" maxWidth={false}>
      <Typography gutterBottom variant="h4" color="primary">
          {userRole === USER_ROLE.DOCTOR ? 'Block my schedule' : 'Block doctor schedule'}
          </Typography>
        <CssBaseline />
        <Paper className={classes.paper}>
          

          <Formik enableReinitialize
            initialValues={{
              startDateTime: startDateTime,
              endDateTime: endDateTime,
              doctorId: doctorId,
            }}
            validationSchema={Yup.object().shape({
              startDateTime: Yup.date()
                .required("From date & time is required")
                .min(
                  new Date(),
                  "From date should be greater than today's date."
                ),
              endDateTime: Yup.date()
                .required("To date & time is required")
                .min(
                  Yup.ref("startDateTime"),
                  "To date should be after from date."
                ),
              doctorId: Yup.string()
                .ensure()
                .required("Please choose doctor."),
            })}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitted(true);
              dispatch(AppointmentActions.blockAppointment(values));
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              touched,
              values,
            }) => (
              <>
                <Box
                  component="div"
                  className={classes.root}
                  style={{ width: "100%" }}
                >
                  <form
                    className={classes.root}
                    onSubmit={handleSubmit}
                    noValidate
                    name="form"
                    style={{ width: "100%" }}
                  >
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={6}>
                        <FormControl margin="normal" style={{ width: "100%" }}>
                          <TextField
                            fullWidth
                            variant="outlined"
                            error={Boolean(
                              touched.startDateTime && errors.startDateTime
                            )}
                            helperText={
                              touched.startDateTime && errors.startDateTime
                            }
                            id="startDateTime"
                            name="startDateTime"
                            label="Start date & time"
                            type="datetime-local"
                            className={classes.textField}
                            onBlur={handleBlur}
                            onChange={(e) => {
                              setSubmitted(false);
                              handleChange(e);
                            }}
                            value={values.startDateTime}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormControl margin="normal" style={{ width: "100%" }}>
                          <TextField
                            fullWidth
                            variant="outlined"
                            error={Boolean(
                              touched.endDateTime && errors.endDateTime
                            )}
                            helperText={
                              touched.endDateTime && errors.endDateTime
                            }
                            id="endDateTime"
                            name="endDateTime"
                            label="End date & time"
                            type="datetime-local"
                            className={classes.textField}
                            onBlur={handleBlur}
                            onChange= {(e) => {
                              setSubmitted(false);
                              handleChange(e);
                            }}
                            value={values.endDateTime}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </FormControl>
                      </Grid>
                      {userRole === USER_ROLE.DOCTOR?null:
                      <Grid item xs={12}>
                        <FormControl margin="normal" style={{ width: "100%" }}>
                          <Autocomplete
                            freeSolo
                            id="free-solo-2-demo"
                            disableClearable
                            options={doctorList.map((option) => option)}
                            getOptionLabel={(option) => {
                              return ((option.firstName ? option.firstName :"")+" "+(option.lastName ? option.lastName:""))}
                            }
                            onChange={(event,nextValue)=> {
                              values.doctorId = nextValue.id;
                              setSubmitted(false);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Doctor Name"
                                variant="outlined"
                                error={Boolean(
                                  touched.doctorId && errors.doctorId
                                )}
                                helperText={
                                  touched.doctorId && errors.doctorId
                                }
                                id="doctorId"
                                name="doctorId"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.patientId}
                                InputProps={{
                                  ...params.InputProps,
                                  type: "search",
                                }}
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>}
                      <Grid item xs={12} className={classes.buttons}>
                        <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          className={classes.button}
                          disabled={isSubmitted}
                        >
                          Submit
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                </Box>
              </>
            )}
          </Formik>
        </Paper>
      </Container>
    </Box>
  );
};
export default Blockshedule;
